module.exports = __webpack_public_path__ + "img/big1-1.88d268c1.jpg";